import React from 'react';

const RelatorioBI = () => (
  <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1485 0H12.8515C12.3757 0 12 0.419693 12 0.920616V6H6.85152C6.37567 6 6 6.4222 6 6.92611V11H0.851521C0.388193 11 0 11.4059 0 11.92V21.08C0 21.5806 0.375671 22 0.851521 22H5.5H6H7H7.5H11.5H12.8515H13H18.1485C18.6243 22 19 21.5803 19 21.0794V0.920616C19 0.419693 18.6118 0.0135385 18.1485 0ZM17.5 1.5H13.5V20.5H17.5V1.5ZM11.5 7.5H7.5V20.5H11.5V7.5ZM5.5 20.5H1.5V12.5H5.5V20.5Z"
    />
  </svg>
);
export default RelatorioBI;
